import { render, staticRenderFns } from "./IframePowerBiPageView2.vue?vue&type=template&id=aca39968&"
import script from "./IframePowerBiPageView2.vue?vue&type=script&lang=js&"
export * from "./IframePowerBiPageView2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aca39968')) {
      api.createRecord('aca39968', component.options)
    } else {
      api.reload('aca39968', component.options)
    }
    module.hot.accept("./IframePowerBiPageView2.vue?vue&type=template&id=aca39968&", function () {
      api.rerender('aca39968', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layouts/IframePowerBiPageView2.vue"
export default component.exports